module.exports = __webpack_public_path__ + "static/media/upload-image.5b749499.png";